import {useSelector} from "react-redux";
import {Image} from "antd";
import React from "react";
import "../../Styles/styles-Chat.css";
import {Header} from "antd/es/layout/layout";
import {useChatbotContext} from "@components/Chatbot/context";
import {BsGear} from "react-icons/bs";

function ChatHeader() {
    const {
        info: { team_logo: team_logo },
    } = useSelector(({ team }) => team);

    const {
        drawerOpen,
        setDrawerOpen
    } = useChatbotContext();

    return (
        <Header className="chat-header-container">
            <div className="chat-header-icon-container">
                <Image
                    id="chat-team-logo"
                    src={team_logo}
                    width={32}
                    preview={false}
                />
            </div>
            <div className="chat-header-title-container">
                <p className="chat-header-title">Whistle AI</p>
                <p className="chat-header-subtitle">Talk to your data...</p>
            </div>
            <div className="chat-header-settings">
                <BsGear
                    size={24}
                    onClick={() => {
                        setDrawerOpen(!drawerOpen);
                    }}
                />
            </div>
        </Header>
    )
}

export default ChatHeader;
